import { yup } from '@guiker/yup-util'

export const thresholdQueryParamsSchema = yup.object<{
  threshold?: number
}>({
  threshold: yup.number().nullable(),
})
